export const baseURL = "https://newadmin.zekkolive.online/";
export const key = "SjqWTaltdsBTeGseZXpujUloxZLEglIchxo0ginPhzc=";
